import { I18nComponente } from "@/types/gerais"

export const TLogini18n: I18nComponente = {
  "pt-BR": {
    email: "email",
    senha: "senha",
    mostrarSenha: "mostrar senha",
    continuar: "continuar",
    entrar: "entrar",
    voltar: "voltar",
    esqueciMinhaSenha: "esqueci minha senha",
    entrarComSingleSignOn: "entrar com single sign on",
    entrarComGoogle: "entrar com google",
    ou: "ou",
    insiraASenha: "Insira a senha",
    insiraUmEmail: "Insira um email",
    insiraUmEmailValido: "Insira um email válido"
  },
  "es-CO": {
    email: "correo eléctronico",
    senha: "contraseña",
    mostrarSenha: "mostrar contraseña",
    continuar: "continuar",
    entrar: "entrar",
    voltar: "volver",
    esqueciMinhaSenha: "olvidé mi contraseña",
    entrarComSingleSignOn: "iniciar sesión con single sign on",
    entrarComGoogle: "iniciar sesión con google",
    ou: "o",
    insiraASenha: "Ingrese la contraseña",
    insiraUmEmail: "Ingrese un correo eléctronico",
    insiraUmEmailValido: "Ingrese un correo eléctronico válido"
  }
}
